import { render, staticRenderFns } from "./topBar.vue?vue&type=template&id=35a56310&scoped=true&"
import script from "./topBar.vue?vue&type=script&lang=js&"
export * from "./topBar.vue?vue&type=script&lang=js&"
import style0 from "./topBar.vue?vue&type=style&index=0&id=35a56310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a56310",
  null
  
)

export default component.exports